<template>
  <div>
    <el-alert title="提示:设置次数最大上限3次,各产品设置次数每减少一次就可在设置一次. " type="warning" show-icon center></el-alert>
    <el-input placeholder="请输入内部锁号,例如：3-123456" v-model="form.chaxun" class="input-with-select">
      <el-button slot="append" icon="el-icon-search" @click="GetForm()">查询</el-button>
    </el-input>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="内部锁号" prop="innerEncryptNo"></el-table-column>
      <el-table-column label="产品名称" prop="moduleName"></el-table-column>
      <el-table-column label="已设置次数">
        <template slot-scope="scope">
          <el-input type="number" v-model="scope.row.num" clearable min="0" max="3"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="350px">
        <template slot-scope="scope">
          <el-button size="mini" @click="shangchuansuo(scope.$index, scope.row)" type="success">确认修改</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      shangchuan: false,
      form: {
        chaxun: "",
      },
      tableData: [],
    };
  },
  methods: {
    GetForm() {
      if (this.form.chaxun.length <= 0) {
        this.$message({
          showClose: true,
          message: "请输入正确的内部锁号",
          type: "error",
        });
        return;
      }
      let formData = new FormData();
      formData.append("innerEncryptNo", this.form.chaxun);
      this.$http
        .post(this.$getaxiosurl("/enc/times/getTrialTimes"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.tableData = [];
            this.tableData = response.data.data;
            this.$message({
              message: "查询成功",
              type: "success",
              duration: 8000,
            });
          } else {
            this.$message({
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
    shangchuansuo(index, row) {
      if (row.num == "") {
        row.num = 0;
      }
      let formData = new FormData();
      formData.append("id", String(row.id));
      formData.append("num", row.num);
      this.$http
        .post(this.$getaxiosurl("/enc/times/saveTrialTimes"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              message: "修改成功",
              type: "success",
              duration: 8000,
            });
            this.GetForm();
          } else {
            this.$message({
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
  },
};
</script>
<style scoped>
</style>
